import { render, staticRenderFns } from "./SetSkill.vue?vue&type=template&id=6380e4f6&scoped=true"
import script from "./SetSkill.vue?vue&type=script&lang=js"
export * from "./SetSkill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6380e4f6",
  null
  
)

export default component.exports